/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { Link, ProductImage } from "../components";

export default function SubCatCard({ subCatURL, product }) {
  const { images, subCatName, catName } = product;
  return (
    <div className="col-md-3 new-episode">
      <Link to={`${catName}/${subCatURL}`}>
        <ProductImage uri={images.alt_images[0].low_res} />
      </Link>
      <h4>{subCatName}</h4>
    </div>
  );
}
